export default {
  labels: {
    agreements: 'Agreements',
    searchByAgreementCode: 'Search by agreement code',
    searchByService: 'Search by service name',
    payer: 'Payer',
    services: 'Services',
    title: 'Agreements configuration',
    basicInformation: 'Basic information',
    regulation2275: 'Regulation 2275',
    packageConfiguration: 'Package configuration',
    groupsConfiguration: 'Groups configuration',
    generalAuditConditions: 'General audit conditions',
    auditRules: 'Audit rules',
    results: 'Results',
    yes: 'Yes',
    no: 'No',
    active: 'Active',
    inactive: 'Inactive',
    email: 'EMAIL',
    virtualDirectory: 'VIRTUAL DIRECTORY',
    s3: 'S3',
    api: 'API',
    sftp: 'SFTP',
    singleFile: 'Single file',
    sftps3: 'SFTP/S3',
    zip: 'ZIP',
    documentaryType: 'Documentary type',
    groupingByCode: 'Grouping by code',
    validate: 'VALIDATE',
    nonValidate: 'NON VALIDATE',
    deleteAuditRule: 'Are you sure you want to delete the audit rule?',
    pmisToValidate: 'PMIS to validate',
    pos: 'PBS',
    noPos: 'NPBS',
    deleteAuditService: 'Are you sure you want to delete the service of the audit rule?',
    confirm: 'This action cannot be undone',
    allServicesAdded: 'All services have been added.',
    pdf: 'PDF',
    pdfAndZip: 'PDF and ZIP',
    deleteGroup: 'Are you sure you want to delete the group {name}?',
    preSettlementConfiguration:'Pre settlement folder configuration',
    dynamicFieldVariables: 'Add variables',
  },
  supportsConfiguration: {
    title: 'Support configuration',
    requiredSupportsAccount: 'Account required supports',
    requiredSupportsCharge: 'Charge required supports',
    search: 'Search by product code, support file name or abrevation',
    supportLevel: 'Support level',
    supportType: 'Support type',
    serviceType: 'Service type',
    name: 'Name',
    abbrevation: 'Abbrevation',
    pmisCode: 'PMIS code',
    productName: 'Product name',
    code: 'Code',
    required: 'Required'
  },
  agreements: {
    agreementCode: 'Agreement code',
		agreementName: 'Agreement name',
    payer: 'Payer',
    serviceTypes: 'Service types',
    normative2275: 'Regulation 2275',
  },
  basicInformation: {
    agreementCode: 'Agreement code',
    sponsorName: 'Sponsor',
		agreementName: 'Agreement',
    taxIdentificationNumber: 'Fiscal number',
    sponsorType: 'Sponsor type',
    sponsorCode: 'Sponsor code',
    requireConcurrentAudit: 'Concurrency',
    responsible: 'Responsible',
  },
  regulation2275: {
    activateRegulation: 'Activate regulation 2275',
    startDateRegulation: 'Start date',
    cuvFormatRegulation: 'CUV Format',
    cuvFormatTypes: {
      json: 'JSON',
      txt: 'TXT',
      jsonWithValidationResults: 'JSON with validation results',
      txtWithValidationResults: 'TXT with validation results',
    }
  },
  packageConfiguration: {
    deliveryChannel: 'Deliver type',
    exportRoute: 'Destiny',
    separateFiles: 'Separate files',
    packageFolderName: 'Directory format',
    packageType: 'Package type',
    exportType: 'Export type',
    folderName: 'File directory',
    formatFile: 'File name',
    buttons: {
      addGroup: 'Add group',
    },
    groupName: 'Group name',
    formatFileName: 'File name',
    supports: 'Supports',
    copiesPlaceholder: 'Copies',
    orderPlaceholder: 'Order',
    tableHeaders: {
      groupName: 'Group name',
      groupFolderName: 'Directory',
      groupFormatFile: 'File format',
      groupSupportsOrderAndCopies: 'Supports, order and copies',
      groupActions: 'Actions',
    },
  },
  zipConfiguration: {
    splitFile: 'Split final files',
    fileSize: 'Max file size in MB',
    fileSizeHint: 'Size that each division of the file will have',
    fileSuffix: 'Split suffix',
    fileSuffixHint: 'Suffix that will be assigned to each division of the file',
    splitZipFile: 'Split ZIP file',
    zipFileSize: 'Max file size in MB',
    zipFileSizeHint: 'Size that each division of the ZIP file will have',
    zipFileSuffix: 'Split suffix',
    zipFileSuffixHint: 'Suffix that will be assigned to each division of the ZIP file',
    zipFolderName: 'ZIP package directory',
    zipFormatFile: 'ZIP file name',
  },
  groupsConfiguration: {
    fileCode: 'File code',
    order: 'Order',
    copies: 'Copies',
    groupName: 'Group name',
    actions: 'Actions',
  },
  auditRules: {
    service: 'Service',
    healthPlan: 'Health plan',
    invoiceAmount: 'Invoice amount',
    minimumAmount: 'Minimum amount ({currency})',
    maximumAmount: 'Maximum amount ({currency})',
    auditType: 'Audit type',
    actions: 'Actions',
    validateAmount: 'Validate amount',
    minimumAmountField: 'Minimum amount',
    maximumAmountField: 'Maximum amount',
    validateService: 'Validate service',
    validatePmis: 'Validate PMIS',
    servicesToValidate: 'Add services',
    code: 'Code',
    name: 'Name',
    posOrNoPos: 'PBS/NPBS',
    serviceCode: 'Service code',
    serviceName: 'Service name',
    preSettlement: 'Pre settlement',
  },
  buttons: {
    supportConfigurations: 'Support configurations',
    assignResponsible: 'Assign responsible',
    edit: 'Edit',
    add: 'Add',
    addPmis: 'Add PMIS',
    addAgreement: 'Add agreement',
    save: 'Save',
    cancel: 'Cancel',
    next: 'Next',
    delete: 'Delete',
    back: 'Back',
  },
  productFinder: {
    selectPmis: 'Select PMIS',
    search: 'Search by code or name',
    service: 'Service',
    healthCarePlanCoverage: 'Health plan',
    check: 'Check',
    code: 'Code',
    name: 'Name',
    description: 'Description'
  },
  messages: {
    errorUpdateAgreement: 'Error updating agreement. Please try again or contact your support team.',
  },
  buildPackages: {
    title: 'Build packages configuration',
    agreementCode: 'Agreement code',
    agreementName: 'Agreement name',
    packageFolderName: 'PDF package directory',
    preview: 'Preview',
    multipleFiles: '*Multiple files',
    multipleDirectory: '*Multiple directories',
    splitedFileWarning: 'The file will be split into parts of {size} MB',
    duplicatedGroup: 'A group with the name {name} already exists. Do you want to replace it?',
    duplicatedGroupWarn: 'This action will replace the existing group settings',
    tabs: {
      folding: 'Folding',
      supports: 'Supports',
    },
    categories: {
      general: 'General',
      INVOICES: 'Invoices',
      PATIENTS: 'Patients',
      PROVIDER_PAYER: 'Provider - Payer',
      PRE_SETTLEMENTS: 'Pre settlement',
    },
    fileFormatFields: {
      accountId: 'Account id',
      baseAccountId: 'Base account id',
      originEventId: 'Origin event id',
      agreementCode: 'Agreement code',
      healthcarePlanCoverage: 'Healthcare plan coverage',
      regime: 'Regime',
      lastServiceType: 'Last service Type',
      lastServiceTypeDescription: 'Last service type description',
      invoiceSource: 'Invoice source',
      invoiceSerial: 'Invoice serial',
      electronicInvoiceNumber: 'Electronic invoice number',
      patientId: 'Patient id',
      patientName: 'Patient name',
      payerName: 'Payer name',
      providerTaxIdentificationNumber: 'Provider tax identification number',
      providerId: 'Provider id',
      originInvoiceGroupId: 'Origin invoice group id',
      invoiceNumber: 'Invoice number',
      invoiceNumberRaw: 'Invoice number (Without prefix)',
    },
  }
}
